<template>
  <el-dialog
    :close-on-click-modal="false"
    :visible.sync="isShow"
    :width="device.desktop?'790px':'90%'"
    append-to-body
    custom-class="comment-dialog"
    title="查看评论">
    <el-scrollbar
      ref="scrollbar"
      :noresize="true"
      style="height:60vh">
      <div class="comment-container">
        <comment-list-item
          v-if="pItem"
          :commentCb="commentCb"
          :item="pItem"
          :pid="pItem.id"
          :showDel="false"
          :showTop="false"
        />
      </div>
      <div class="split-box"></div>
      <div class="comment-container">
        <template v-for="(child) in list">
          <comment-list-item
            :key="child.id"
            :commentCb="commentCb"
            :item="child"
            :pUid="item.user.uid"
            :pid="item.id"
            @onDel="onDelComment"/>
        </template>
        <div v-if="loading>2" class="loading">
          <template v-if="loading==2">
            <i class="el-icon-loading"></i>加载中...
          </template>
          <template v-if="loading==3">没有更多内容了</template>
        </div>
      </div>
    </el-scrollbar>
  </el-dialog>
</template>

<script>
  import { apiCommentList, apiCommentAdd } from '@/api/commentApi';
  import eventBus from '@/plugins/eventBus';
  import CommentListItem from '@/views/wiki/components/commentListItem';
  import { throttle } from '@/plugins/util';

  export default {
    name: 'commentDialog',
    mixins: [],
    props: {},
    model: {},
    components: { CommentListItem },
    data () {
      return {
        pagination: {
          limit: 10,
          page_no: 0,
          page_total: 1,
          total: 0
        },
        isShow: false,
        list: [],
        item: null,
        pItem: null,
        scrollTop: 0,
        scrollHeight: 0,
        clientHeight: 0,
        loading: 1
      };
    },
    computed: {},
    methods: {
      onShowComment (item) {
        this.isShow = true;
        this.list = [];
        this.pagination = {
          limit: 10,
          page_no: 0,
          page_total: 1,
          total: 0
        };
        this.loading = 1;
        this.item = item;
        this.pItem = JSON.parse(JSON.stringify(item));
        this.pItem.child = null;
        this.getCommentList();
        setTimeout(() => {
          this.handleScroll();
        }, 200);
      },
      getCommentList () {
        let {
          pagination
        } = this;
        if (this.loading > 1) return;
        ++pagination.page_no;
        let params = {
          ...this.pagination,
          content_id: this.item.content_id,
          pid: this.item.id
        };
        this.loading = 2;
        apiCommentList(params).then(res => {
          this.list = this.list.concat(res.data);
          this.pagination = res.meta.pagination;
          setTimeout(() => {
            if (this.pagination.page_no >= this.pagination.page_total) {
              this.loading = 3;
            }
          });
        }).finally(_ => {
          this.loading = 1;
        });
      },
      onDelComment (item) {
        let index = this.list.indexOf(item);
        console.log(index);
        this.list.splice(index, 1);
      },
      // 评论回调
      commentCb (item) {
        this.list.unshift(item);
        console.log(this.item);
        this.item.child.unshift(item);
      },
      handleScroll () {
        let $scroll = this.$refs.scrollbar.$el.querySelector('.el-scrollbar__wrap');
        $scroll.addEventListener('scroll', throttle((e) => {
          this.scrollTop = $scroll.scrollTop;
          this.scrollHeight = $scroll.scrollHeight;
          this.clientHeight = $scroll.clientHeight;
          if (this.scrollHeight - (this.scrollTop + this.clientHeight) <= 300) {
            this.getCommentList();
          }
        }, 200));
      }
    },
    watch: {},
    created () {
    },
    beforeMount() {
      eventBus.$on('onShowComment', this.onShowComment);
    },
    mounted () {
    },
    updated () {
    },
    beforeDestroy () {
    },
    destroyed () {
    }

  };
</script>

<style lang="less" scoped>
/deep/ .comment-dialog {
  .el-dialog__header {
    border-bottom: 1px solid @border-basic;
  }

  .el-dialog__body {
    height: 60vh;
    padding: 0;
  }

  .split-box {
    width: 100%;
    height: 10px;
    background: #f5f5f5;
  }
}

.comment-container {
  padding: 14px 20px;
}

.loading {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #bbb;
  padding: 30px;
}
</style>
